import { AuthType } from '@/constants/auth-type';
import http from '@/utils/http';

export type CreateBusinessPermissionData = {
  /** 业务ID */
  productCode: string;
  /** 权限数据列表：CAS账号|地区|部门|权限类型，中间|隔开，多个地区和部门逗号隔开 */
  casList: string[];
};

export type ModifyBusinessPermissionData = {
  id: string;
  /** 业务ID */
  productCode: string;
  /** 地区ID */
  areaCode: string;
  /** 组别ID */
  departmentCode: string;
  /** 权限类型 */
  authType: AuthType;
};

export type ListBusinessPermissionData = {
  /** CAS账号 */
  cas?: string;
  /** 用户名 */
  casName?: string;
  /** 业务 */
  productCode?: string;
  /** 地区 */
  areaCode?: string;
  /** 组别 */
  departmentCode?: string;
  /** 页码 */
  pageIndex?: number;
  /** 每页尺寸 */
  pageSize?: number;
};

/** 业务权限 */
const businessPermissionApi = {
  /**
   * 添加业务权限
   * @param data 参数
   */
  create(data: CreateBusinessPermissionData) {
    return http.post('/api/user/createBusinessPermission', data);
  },
  /**
   * 编辑业务权限
   * @param data
   */
  modify(data: ModifyBusinessPermissionData) {
    return http.post('/api/user/modifyBusinessPermission', data);
  },
  /**
   * 查询业务权限列表
   * @param data 参数
   */
  list(data: ListBusinessPermissionData) {
    return http.post('/api/user/searchBusinessPermission', data);
  },
  /**
   * 删除业务权限记录
   * @param id 记录ID
   */
  removeBusinessPermission(id: string) {
    return http.post('/api/user/remove', { id });
  },
  /**
   * 导出业务权限记录
   * @param data 参数
   */
  export(data: ListBusinessPermissionData) {
    return http.post('/api/user/exportBusinessPermission', data, { responseType: 'blob' });
  },
};

export default businessPermissionApi;
